module.exports = "/fonts/opensansextrabold.ttf";